import Vue from 'vue/dist/vue.esm.js'
import 'jquery'
import 'bootstrap'
import { isNil, camelCase } from 'lodash'

KCVS.Views.VueReportDocumentEditView = Vue.extend(
  store: KCVS.Stores.InformativeFieldsStore
  data: ->
    isModalOpen: false
    stateNotChangeable: false
    selectedDocumentGroup: ''
    informativeFields: {}
    documentId: null
    otherPartyName: ''
    fAmountWithoutVat: 0
    fIrAmount: 0
    fEdAmount: 0
    fEaAmount: 0
    fNumber: ''
    projectStartDate: ''
    documentDate: ''

  mounted: ->
    @setOtherPartyTotalForAllAmountFields()
    @setupDocumentDateDatepickerListener()
    $(document).on 'select2:select', '.nested-fields select', (e) =>
      @otherPartyName = e.params.data.name
      @setOtherPartyTotalForAllAmountFields()
    $(document).on 'click', '.remove_fields', (e) =>
      @removeSumDisplays()
      @otherPartyName = ''

  created: ->
    @$store.state.informativeFields = @informativeFields
    @$store.state.filterValue = String(@selectedDocumentGroup.id)
    @setOtherPartyTotalForAllAmountFields()

  computed:
    showFinanceBlock: ->
      ['finance_document', 'legal_document'].indexOf(@selectedDocumentGroup.document_type) > -1

    showLegalBlock: ->
      'legal_document' == @selectedDocumentGroup.document_type

    showSalariesBlock: ->
      cost_group = @selectedDocumentGroup.project_cost_group
      return false unless cost_group
      @selectedDocumentGroup.relevant_column_number == '2' && cost_group.code == 'personnel_costs'

    showExpenseDescription: ->
      @selectedDocumentGroup.relevant_column_number == '2'

    showInvolvedEmployeesBlock: ->
      @selectedDocumentGroup.relevant_column_number == 'involved_employee_order'

    documentDateError: ->
      return '' unless @documentDate && @projectStartDate

      docDate = Helper.parseDate(@documentDate)
      projStartDate = Helper.parseDate(@projectStartDate)

      if docDate && projStartDate && docDate < projStartDate
        I18n.t('javascript.document_date_before_project_start',
          project_start_date: @projectStartDate)
      else
        ''

  methods:
    openModal: (e) ->
      e.preventDefault()
      @isModalOpen = true unless @stateNotChangeable
    toggleDataBlock: (e) ->
      $(e.target).next(".data-block").toggle()
    changeSelectedDocumentGroup: (selectedGroup) ->
      @selectedDocumentGroup = selectedGroup
      @updateTooltipContent()
    closeModal: ->
      @isModalOpen = false
    lockState: ->
      @stateNotChangeable = true
    updateTooltipContent: ->
      newValue = String(@selectedDocumentGroup.id)
      tooltipElements = document.querySelectorAll('.info-btn[data-toggle="tooltip"]')
      @.$nextTick ->
        for element in tooltipElements
          fieldName = element.getAttribute('data-input-field')
          informativeField = @informativeFields.filter (field) ->
            if field.filter == "no_filter"
              field.input_field_name == fieldName
            else
              field.input_field_name == fieldName && field.filter_value == newValue
          [0]
          if informativeField[0] && informativeField[0].code != '' && informativeField[0].description != '' && informativeField[0].show_field
            tooltipContent = "#{informativeField[0].code}:\n#{informativeField[0].description}"
            element.style.display = ''
            element.setAttribute('data-original-title', tooltipContent)
            $('[data-toggle="tooltip"]').tooltip()
          else
            element.setAttribute('data-original-title', '')
            element.style.display = 'none'

    fetchAndSetOtherPartyDocumentAmountSum: (sumAttribute) ->
      fieldName = sumAttribute.replace('_cents', '')

      $.ajax
        url: "/admin/report_documents/#{@documentId}/other_party_document_amount_sum"
        data:
          sum_attribute: sumAttribute
          other_party_name: @otherPartyName
          current_input_field_value: @[camelCase(fieldName)]
          f_number_value: @fNumber
        success: (response) ->
          inputField = document.querySelector("input[name='report_document[#{fieldName}]']")
          existingSumDisplay = inputField.parentNode.querySelector('.sum-display')
          existingSumDisplay?.remove()

          sumDisplay = document.createElement('div')
          sumDisplay.className = 'sum-display'
          sumDisplay.textContent = "(#{response.amount_sum})"

          inputField.parentNode.insertBefore(sumDisplay, inputField.nextSibling)

    setOtherPartyTotalForAllAmountFields: ->
      @fetchAndSetOtherPartyDocumentAmountSum('f_amount_without_vat_cents')
      @fetchAndSetOtherPartyDocumentAmountSum('f_ir_amount_cents')
      @fetchAndSetOtherPartyDocumentAmountSum('f_ed_amount_cents')
      @fetchAndSetOtherPartyDocumentAmountSum('f_ea_amount_cents')

    removeSumDisplays: ->
      document.querySelectorAll('.sum-display').forEach (element) ->
        element.remove()

    setupDocumentDateDatepickerListener: ->
      $('input[name="report_document[document_date]"]').on 'change', (e) =>
        @documentDate = e.target.value

  watch:
    fAmountWithoutVat: (newVal, oldVal) ->
      return if isNil(newVal) && newVal != oldVal
      @fetchAndSetOtherPartyDocumentAmountSum('f_amount_without_vat_cents')
    fIrAmount: (newVal, oldVal) ->
      return if isNil(newVal) && newVal != oldVal
      @fetchAndSetOtherPartyDocumentAmountSum('f_ir_amount_cents')
    fEdAmount: (newVal, oldVal) ->
      return if isNil(newVal) && newVal != oldVal
      @fetchAndSetOtherPartyDocumentAmountSum('f_ed_amount_cents')
    fEaAmount: (newVal, oldVal) ->
      return if isNil(newVal) && newVal != oldVal
      @fetchAndSetOtherPartyDocumentAmountSum('f_ea_amount_cents')
    fNumber: (newVal, oldVal) ->
      return if isNil(newVal) && newVal != oldVal
      @fetchAndSetOtherPartyDocumentAmountSum('f_amount_without_vat_cents')
)
